import service from '@/api/components';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service('admin/components'),
    versions: [],
    ctas: []
};

export const getters = {
    versions: function (state) {
        return state.versions;
    },
    ctas: function (state) {
        return state.ctas;
    }
};

export const mutations = {
    'SET_VERSIONS': function (state, versions = []) {
        state.versions = versions;
    },
    'ADD_VERSION': function (state, version) {
        state.versions.unshift(version);
    },
    'REPLACE_VERSION': function (state, version) {
        const index = state.versions.findIndex(item => item.id === version.id);

        if (index !== -1) {
            state.versions[index] = version;
            state.versions = JSON.parse(JSON.stringify(state.versions));
        }
    },
    'SET_CTAS': function (state, ctas = []) {
        state.ctas = ctas;
    },
    'ADD_CTA': function (state, cta) {
        state.ctas.push(cta);
    },
    'REMOVE_CTA': function (state, id) {
        const index = state.ctas.findIndex(item => item.id === id);

        if (index !== -1) {
            state.ctas.splice(index, 1);
        }
    }
};

export const actions = {
    fetchGroups: function ({state}) {
        return state.service.fetchGroups().then(response => {
            return response.data || [];
        }).catch(() => {
            return [];
        });
    },

    storeGroup: function ({commit, state}, payload) {
        loading(commit);

        return state.service.storeGroup(payload).then(response => {
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    versions: function ({commit, state}, componentId) {
        loading(commit);

        return state.service.fetchVersions(componentId).then(response => {
            commit('SET_VERSIONS', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    storeVersion: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.storeVersion(id, data).then(response => {
            commit('ADD_VERSION', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    publishVersion: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.publishVersion(id, data).then(response => {
            commit('REPLACE_VERSION', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    deprecateVersion: function ({commit, state}, id) {
        loading(commit);

        return state.service.deprecateVersion(id).then(response => {
            commit('REPLACE_VERSION', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    ctas: function ({commit, state}, componentId) {
        loading(commit);

        return state.service.fetchCtas(componentId).then(response => {
            commit('SET_CTAS', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    storeCta: function ({commit, state}, {versionId, data}) {
        loading(commit);

        return state.service.storeCta(versionId, data).then(response => {
            commit('ADD_CTA', response);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response;
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    destroyCta: function ({commit, state}, id) {
        loading(commit);

        return state.service.destroyCta(id).then(() => {
            commit('REMOVE_CTA', id);
            alert(commit, this.$t('request.deletion_is_successful'));
            loading(commit, false);
        }).catch((e) => {
            handleError(e, commit);
            throw e;
        });
    },

    clearVersions: function ({commit}) {
        commit('SET_VERSIONS', []);
    },

    clearCtas: function ({commit}) {
        commit('SET_CTAS', []);
    }
};
